// Date utilities for Pro Vertical
//
// PROBLEM: A date stored as "YYYY-MM-DD" without time is interpreted by
// JavaScript as UTC midnight. When converting to local time in Chile (UTC-3/-4)
// it becomes the previous day. This module exposes safe parsing + formatting.

/**
 * parseLocalDate("2026-05-16") -> Date object set to 2026-05-16 00:00 LOCAL time
 * Accepts also ISO strings with time; if so, returns standard Date.
 */
export function parseLocalDate(input) {
  if (!input) return null;
  if (input instanceof Date) return input;
  const s = String(input).trim();
  // Pure date "YYYY-MM-DD"
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    let year = Number(m[1]);
    // Fix legacy: años en 4 dígitos con relleno "00XX" (bug del <input type="date"> del navegador
    // cuando el usuario tipeaba solo 2 dígitos). Los remapeamos a 20XX.
    if (year < 100) year = 2000 + year;
    return new Date(year, Number(m[2]) - 1, Number(m[3]));
  }
  // Otherwise rely on Date parsing (with time/tz)
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}

/**
 * formatEventDate(dateInput, locale, options)
 * Locale-aware formatting that respects local-day intent.
 */
export function formatEventDate(input, locale = "es-CL", options = { day: "numeric", month: "long", year: "numeric" }) {
  const d = parseLocalDate(input);
  if (!d) return "";
  try {
    return d.toLocaleDateString(locale, options);
  } catch {
    return d.toLocaleDateString("es-CL", options);
  }
}

/**
 * shortDate(dateInput, locale)
 * Compact "16 may 2026" style.
 */
export function shortDate(input, locale = "es-CL") {
  return formatEventDate(input, locale, { day: "numeric", month: "short", year: "numeric" });
}
